import React from 'react';
import { Link } from 'react-router-dom';
import { useLoginModal } from '../context/LoginModalContext';
import { FadeUp } from './motion/Reveal';
import { SUPPORT_EMAIL, SUPPORT_WHATSAPP_DISPLAY, whatsappLink } from '../config/supportContact';
import '../styles/Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  const { openLoginModal } = useLoginModal();

  return (
    <footer className="site-footer" role="contentinfo">
      <FadeUp>
        <div className="site-footer__inner">
        <div className="site-footer__brand">
          <img
            src="/branding/logo-display.png"
            alt="AirFlyNow"
            className="site-footer__logo"
          />
          <p className="site-footer__tagline">
            Book Flights Faster using Smart Tagging.
          </p>
        </div>

        <nav className="site-footer__links" aria-label="Footer navigation">
          <div className="site-footer__col">
            <span className="site-footer__col-title">Product</span>
            <Link to="/" className="site-footer__link">Home</Link>
            <Link to="/about" className="site-footer__link">About</Link>
            <Link to="/search-flights" className="site-footer__link">Book Flights</Link>
            <Link to="/hotels" className="site-footer__link">Hotels</Link>
            <Link to="/my-bookings" className="site-footer__link">My Bookings</Link>
          </div>

          <div className="site-footer__col">
            <span className="site-footer__col-title">Account</span>
            <button type="button" className="site-footer__link" onClick={() => openLoginModal()}>Login</button>
            <Link to="/create-account" className="site-footer__link">Sign Up</Link>
            <Link to="/forgot-password" className="site-footer__link">Reset Password</Link>
          </div>

          <div className="site-footer__col">
            <span className="site-footer__col-title">Support</span>
            <Link to="/faq" className="site-footer__link">FAQ</Link>
            <Link to="/contact" className="site-footer__link">Contact</Link>
            <Link to="/carriers" className="site-footer__link">Airline Directory</Link>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="site-footer__link">
              {SUPPORT_EMAIL}
            </a>
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="site-footer__link">
              WhatsApp {SUPPORT_WHATSAPP_DISPLAY}
            </a>
            <span className="site-footer__hours">24/7 support</span>
          </div>

          <div className="site-footer__col">
            <span className="site-footer__col-title">Connect</span>
            <a href="https://au.linkedin.com/company/airflynow" target="_blank" rel="noopener noreferrer" className="site-footer__link">
              LinkedIn
            </a>
          </div>

          <div className="site-footer__col">
            <span className="site-footer__col-title">Legal</span>
            <Link to="/privacy-policy" className="site-footer__link">Privacy Policy</Link>
            <Link to="/terms-of-use" className="site-footer__link">Terms of Use</Link>
            <Link to="/cookie-policy" className="site-footer__link">Cookie Policy</Link>
          </div>
        </nav>
      </div>
      </FadeUp>

      <div className="site-footer__bottom">
        <span className="site-footer__copy">
          &copy; {year} AIRFLYNOW Pty Ltd ACN 697 237 399 | ABN 99 697 237 399. All rights reserved.
        </span>
        <span className="site-footer__disclaimer">
          Fares shown include taxes. Prices may change — confirm at checkout.
        </span>
      </div>
    </footer>
  );
}

export default Footer;
